





















import Vue from 'vue';
import customerClient from '../apis';

export default Vue.extend({
  data() {
    return {
      enabled: false,
    };
  },
  methods: {
    getTraceStatus() {
      customerClient.getTraceStatus().success(r => {
        this.enabled = r.enabled;
      });
    },
    setTraceStatus() {
      customerClient.setTraceStatus({
        enabled: this.enabled,
      });
    },
  },
  mounted() {
    this.getTraceStatus();
  },
});
